import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import Facebook from "../../assets/icons/facebook.svg";
import Instagram from "../../assets/icons/instagram.svg";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ObfuscatedLink from "../obfuscated-link";

const Footer = () => {
  const data = useStaticQuery(query);
  return (
    <footer >
      <div className="container">
        <div className="grid  sm:grid-cols-3 gap-x-4 text-sm">


          <div className="flex">
            <div className="w-32">
              <GatsbyImage
                image={getImage(data.image1)}
                className="w-full"
                alt="Logo de l'atelier du totebag"
              />
            </div>
            <div className="flex-1">
              <div className="font-semibold text-base text-white uppercase mb-2">L'Atelier du Tote Bag</div>
              <ul className="mb-6">
                <li><Link to="/l-atelier-du-tote-bag">Qui sommes-nous ?</Link></li>
                <li><Link to="/tote-bags-inspirations">Nos réalisations</Link></li>
                <li><Link to="/contacter-l-atelier-du-tote-bag">Nous contacter</Link></li>
                <li><Link to="/auteur-jonathan">Le blog</Link></li>
                <li><ObfuscatedLink className="text-white" to="/questions-fabrication-tote-bags-personnalises">Les questions / réponses</ObfuscatedLink></li>
                <li><Link to="/grossiste-tote-bag">Grossiste tote bag</Link></li>
                <li><Link to="/sacs-labellises-oeko-tex-pour-l-environnement">Labellisation OEKO-TEX® STANDARD 100</Link></li>

                <li><Link to="/conditions-generales-de-vente">Conditions générales de vente</Link></li>
                <li><Link to="/mentions-legales">Mentions légales</Link></li>
                <li><Link to="/cookie-preferences">Politique de confidentialité</Link></li>
                <li><Link to="/sitemap-0.xml">Plan de site</Link></li>
                {/* <li><Link to="/delai-de-livraison"><b>Délai de livraison</b></Link></li> */}
              </ul>


              <div className="font-semibold text-base text-white uppercase mb-2">Les marquages</div>
              <ul className="mb-6">
                <li><Link to="/impression-serigraphie">La sérigraphie</Link></li>
                <li><Link to="/impression-numerique">L'impression numérique</Link></li>
                <li><Link to="/impression-transfert">L'impression transfert</Link></li>
                <li><Link to="/impression-broderie">La broderie</Link></li>

                {/* <li><Link to="/broderie-3d">Broderie 3D</Link></li> */}
                {/* <li><Link to="/tote-bags-blanc-a-personnaliser" >Tote bag blancs personnalisables</Link></li> */}
                {/* <li><Link to="/tote-bags-vierge-a-personnaliser" >Tote bag vierge à personnaliser (couleur de votre choix)</Link></li> */}
              </ul>
            </div>
          </div>

          <div>
            {/* <div className="font-semibold text-base text-white uppercase mb-2">Nos produits par matière</div> */}
            {/* <ul className="mb-6"> */}
            {/* <li><Link to="/categorie-produit/sac-tissu-personnalise-publicitaire" >Sacs en coton</Link></li> */}
            {/* <li><Link to="/categorie-produit/sacs-publicitaires-coton-biologique" >Sacs en coton biologique</Link></li> */}
            {/* <li><Link to="/categorie-produit/sacs-en-toile-de-jute-personnalises" >Sacs en toile de jute</Link></li> */}
            {/* </ul> */}
            {/* <ul className="mb-6">
              <li><Link to="/categorie-produit/tote-bags-personnalises-coton-biologique" >Tote bags personnalisés en coton biologique </Link></li>
              <li><Link to="/categorie-produit/pochettes-publicitaires-bio-personnalisees" >Pochettes personnalisables bio</Link></li>
              <li><Link to="/categorie-produit/tote-bags-grand-format-xxl-personnalises" >Tote bags personnalisés grand format</Link></li>
              <li><Link to="/categorie-produit/sacs-coton-ecologique-personnalises" >Sacs en coton personnalisables</Link></li>
            </ul> */}

            <div className="font-semibold text-base text-white uppercase mb-2">Nos produits personnalisables </div>
            <ul className="mb-6">
              <li><Link to={'/categorie-produit/tote-bags-personnalises'}>Tote bags personnalisés</Link></li>
              <li><Link to={'/categorie-produit/cabas-personnalises'}>Sacs cabas personnalisés</Link></li>
              <li><Link to={'/categorie-produit/sac-pochon-publicitaire-personnalise'}>Pochettes personnalisées</Link></li>
              <li><Link to={'/categorie-produit/trousses-personnalisees'}>Trousses personnalisées</Link></li>
              <li><Link to={'/categorie-produit/sac-a-dos-personnalise-publicitaire'}>Sacs à dos publicitaires personnalisés</Link></li>
              <li><Link to={'/categorie-produit/sac-de-sport-personnalise-publicitaire'}>Sacs de sport publicitaires personnalisés</Link></li>
              <li><Link to={'/categorie-produit/sac-a-pain-tissu-personnalise-publicitaire'}>Sacs à pain personnalisés</Link></li>
              <li><Link to={'/categorie-produit/tote-bag-en-jean-personnalisable'}>Tote bags en jean personnalisés</Link></li>

              <li><Link to={'/categorie-produit/tote-bags-francais-personnalises'}>Tote bags made in France personnalisés</Link></li>
              <li><Link to={'/categorie-produit/tote-bags-grand-format-xxl-personnalises'}>Tote bags personnalisés grand format</Link></li>


              <li><Link to={'/tote-bag-personnalises-livraison-rapide'}>Tot bag personnalisés avec livraison rapide</Link></li>
              <li><Link to={'/tote-bags-noirs-personnalises'}>Sacs personnalisés avec logo</Link></li>

            </ul>

            <div className="font-semibold text-base text-white uppercase mb-2">Fabrication sur mesure</div>
            <ul className="mb-6">
              <li><Link to={'/tote-bag-sur-mesure'}>Sacs personnalisés sur mesure</Link></li>
            </ul>



          </div>


          <div>
            {/* <div className="font-semibold text-base text-white uppercase mb-2">Nos produits par couleur</div> */}
            {/* <ul className="mb-6"> */}
            {/* <li><Link to={"/tote-bags-noirs-personnalises"}>Tote bags noir personnalisés</Link></li> */}
            {/* <li><Link to={"/tote-bags-bleus-personnalises"}>Tote bags bleu personnalisés</Link></li> */}
            {/* </ul> */}


            <div className="font-semibold text-base text-white uppercase mb-2">Nos sacs personnalisés par couleur</div>
            <ul className="mb-6">
              <li><Link to={'/categorie-produit/blanc'}>Tote bags blancs personnalisés</Link></li>
              <li><Link to={'/categorie-produit/noir'}>Tote bags noirs personnalisés</Link></li>
              <li><Link to={'/categorie-produit/jaune'}>Tote bags jaunes personnalisés</Link></li>
              <li><Link to={'/categorie-produit/rouge'}>Tote bags rouges personnalisés</Link></li>
              <li><Link to={'/categorie-produit/bleu'}>Tote bags bleus personnalisés</Link></li>
              <li><Link to={'/categorie-produit/vert'}>Tote bags verts personnalisés</Link></li>
            </ul>

            <div className="font-semibold text-base text-white uppercase mb-2">Nos textiles personnalisés</div>
            <ul className="mb-6">
              <li><ObfuscatedLink className="text-white" to={'/categorie-produit/casquettes-personnalisees'}>Casquettes personnalisées</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to={'/categorie-produit/polos-personnalises'}>Polos personnalisés</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to={'/categorie-produit/pulls-personnalises'}>Pulls personnalisés</ObfuscatedLink></li>
              <li><ObfuscatedLink className="text-white" to={'/categorie-produit/t-shirts-personnalises'}>T-shirts personnalisés</ObfuscatedLink></li>
            </ul>

            <div className="font-semibold text-base text-white uppercase mb-2">Contact</div>


            <ul className="mb-6">
              <li>
                <ObfuscatedLink className="text-white" to="mailto: devis@latelierdutotebag.com">devis@latelierdutotebag.com</ObfuscatedLink>
              </li>
              <li className="flex space-x-6">
                <a
                  className="block border-2 border-blue-light rounded-full p-2 hover:bg-blue-light"
                  href="https://www.facebook.com/latelierdutotebag"
                  target="_blank"
                  rel="nofollow, noreferrer"
                >
                  <Facebook width="20" className="text-white fill-current" />
                </a>
                <a
                  className="block border-2 border-blue-light rounded-full p-2 hover:bg-blue-light"
                  href="https://www.instagram.com/latelierdutotebag"
                  target="_blank"
                  rel="nofollow, noreferrer"
                >
                  <Instagram width="20" className="text-white fill-current" />
                </a>
              </li>

            </ul>

          </div>

          {/* <div>
            <ul className="mb-6">
              <li><span className="text-base font-semibold text-white">L'atelier du tote bag</span></li>
              <li><Link to="/l-atelier-du-tote-bag">Qui sommes-nous ?</Link></li>
              <li><Link to="/tote-bags-inspirations">Nos réalisations</Link></li>
              <li><Link to="/contacter-l-atelier-du-tote-bag">Nous contacter</Link></li>
              <li><Link to="/auteur-jonathan">Le blog</Link></li>
              <li><Link to="/questions-fabrication-tote-bags-personnalises">Les questions / réponses</Link></li>
              <li><Link to="/grossiste-tote-bag">Grossiste tote bag</Link></li>
            </ul>
          </div> */}


        </div>
      </div>
      <div className="text-xs text-gray-200 text-center mt-4">
        © Copyright {new Date().getFullYear()}, L'atelier du Tote bag
      </div>
    </footer >
  );
};

const query = graphql`
  query {
    image1: file(
      relativePath: { eq: "Logo-latelierducoton.png" }
      sourceInstanceName: { eq: "uploads" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 150, quality: 100) 
      }
    }
  }
`;

export default Footer;
